// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"b33726b8","209":"e3c2e599","461":"40fa81c3"}[chunkId] + ".chunk.css";
};